// Record errors within fastdom:
// https://github.com/wilsonpage/fastdom#exceptions

define('common/utils/fastdom-errors',[
    'fastdom',
    'raven'
], function (
    fastdom,
    raven
) {
    fastdom.onError = function (error) {
        raven.captureException(error, {
            tags: {
                feature: 'fastdom'
            }
        });
        window.console.error(error);
    };
});

